export class RestoreRdsInstanceClasses {
    'instanceClasses';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "instanceClasses",
            "baseName": "instanceClasses",
            "type": "Array<string>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return RestoreRdsInstanceClasses.attributeTypeMap;
    }
    constructor() {
    }
}
